<template>
 <div class="w-100 h-100">
   <div class="flex just-center align-center"><img src="http://img.51miz.com/preview/element/00/01/07/07/E-1070747-5A7E8DBE.jpg!/quality/90/unsharp/true/compress/true/format/jpg"></div>
 </div>
</template>

<script>
export default {
  name: 'notFound',
  data () {
    return {
    }
  },
  created(){

  },
  mounted(){

  },
  methods:{
    
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/default/404.vue